var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.577,
    height: 29.323,
    viewBox: "0 0 43.577 29.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "marker",
    d: "M21.661,3A14.69,14.69,0,0,0,7,17.661c0,2.291.929,4.919,2.189,7.789a90.211,90.211,0,0,0,4.531,8.756c3.3,5.683,6.618,10.436,6.618,10.436l1.324,1.935,1.324-1.935s3.322-4.754,6.618-10.436a90.211,90.211,0,0,0,4.531-8.756c1.26-2.87,2.189-5.5,2.189-7.789A14.69,14.69,0,0,0,21.661,3Z",
    transform: "translate(46.577 -7) rotate(90)",
    fill: "#ea4967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelMarker);
export default __webpack_public_path__ + "static/media/wheelMarker.7e3ca9109e6bc75288557f06add74e7f.svg";
export { ForwardRef as ReactComponent };